import { createContext, useContext } from 'react';
import { noop } from "../../utils/noop";
export var SheetContext = createContext({
  onRequestClose: noop,
  isShowing: false,
  id: null
});
export var useSheetContext = function useSheetContext() {
  return useContext(SheetContext);
};